module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"ui":{"views":{"terms":{"meta_tags":{"description":"Terms of Service of the CAPinside GmbH","title":"Terms of Service"}}}}}}')
  delete Component.options._Ctor
}
